import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Typography,
  Button,
  MenuItem,
  Grid,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Card,
  CardContent,
  CardMedia,
  Checkbox,
  FormControlLabel,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  ListItemAvatar,
  Avatar,
  Snackbar,
  Alert,
  Select,
  FormControl,
  InputLabel,  
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useParams } from "react-router-dom";
import PackageServices from "../../services/externalServices/TourPackageServices/packageServices";
import PlaceServices from "../../services/externalServices/TourPackageServices/placeServices";
import { styles } from "./styles";

function EditPackage() {
  const { id } = useParams();
  const isEditMode = Boolean(id);
  const [selectedLanguage, setSelectedLanguage] = useState("en");
  const [editedData, setEditedData] = useState({
    type: "",
    city: "",
    cityScope: "",
    listTitle: {
      en: "",
      kn: "",
      te: "",
      ta: "",
      ml: "",
      hi: "",
    },
    listHeading: {
      en: "",
      kn: "",
      te: "",
      ta: "",
      ml: "",
      hi: "",
    },
    listSubheading: {
      en: "",
      kn: "",
      te: "",
      ta: "",
      ml: "",
      hi: "",
    },
    detailTitle: {
      en: "",
      kn: "",
      te: "",
      ta: "",
      ml: "",
      hi: "",
    },
    detailHeading: {
      en: "",
      kn: "",
      te: "",
      ta: "",
      ml: "",
      hi: "",
    },
    detailSubheading: {
      en: "",
      kn: "",
      te: "",
      ta: "",
      ml: "",
      hi: "",
    },
    detailDescription_1: {
      en: "",
      kn: "",
      te: "",
      ta: "",
      ml: "",
      hi: "",
    },
    detailDescription_2: {
      en: "",
      kn: "",
      te: "",
      ta: "",
      ml: "",
      hi: "",
    },
    thumbnailImage: "",
    backgroundType: "",
    backgroundURL: "",
    featureVideo: "",
    sliderImages: ["", "", ""],
    bestSeasons: {
      en: ["", "", ""],
      kn: ["", "", ""],
      te: ["", "", ""],
      ta: ["", "", ""],
      ml: ["", "", ""],
      hi: ["", "", ""],
    },
    tags: {
      en: ["", ""],
      kn: ["", ""],
      te: ["", ""],
      ta: ["", ""],
      ml: ["", ""],
      hi: ["", ""],
    },
    totalDays: "",
    startTime: "",
    endTime: "",
    bookBeforeTime: "",
    remarks: "",
    placesIncluded: [
      {
        placeId: null,
        sequence: 1,
        isEnabled: true,
      },
    ],
    internalComments: "",
    totalBooked: 0,
    totalCancelled: 0,
    priority: 1,
    isEnabled: false,
    bookingLockedReason: {
      en: "",
      kn: "",
      te: "",
      ta: "",
      ml: "",
      hi: "",
    },
    isBookingLocked: false,
    minimumPlacesToEndTrip: 0,
    biddingConfiguration: {
      isAutoBid:false,
      initialRadius: 0,
      incrementByRadius: 0,
      maxRadius: 0,
      waitTimeBetweenRadius: 0,
      waitTimeAfterSearchComplete: 0,
      bidCountToStopSearch: 0,
    },

    availableTimeSlots: ["", "", "", ""],
    idealPrice: 0,
    pricePerKm: 0,
    additionalNote: {
      en: ["", "", ""],
      kn: ["", "", ""],
      te: ["", "", ""],
      ta: ["", "", ""],
      ml: ["", "", ""],
      hi: ["", "", ""],
    },
    sampleAudioGuide: {
      en: {
        name: "",
        language: "en",
        isEnabled: false,
        audioUrl: "",
        subtitlesUrl: "",
      },
      kn: {
        name: "",
        language: "",
        isEnabled: false,
        audioUrl: "",
        subtitlesUrl: "",
      },
    },
    audioGuide: {
      name: "",
      language: "",
      isEnabled: false,
      short: {  audioUrl: "", subtitlesUrl: "" },
      medium: {  audioUrl: "", subtitlesUrl: "" },
      long: {audioUrl: "", subtitlesUrl: "" },
    },
    isEnabledAudioGuide: false,
  });
  const [places, setPlaces] = useState([]);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (isEditMode) {
      getPackageDetailsById(id);
    }
  }, [isEditMode, id]);

  useEffect(() => {
    if (!editedData.sampleAudioGuide) {
      setEditedData((prev) => ({
        ...prev,
        sampleAudioGuide: {
          en: {
            name: "",
            language: "en",
            isEnabled: false,
            audioUrl: "",
            subtitlesUrl: "",
          },
          kn: {
            name: "",
            language: "kn",
            isEnabled: false,
            audioUrl: "",
            subtitlesUrl: "",
          },
          // te: { name: "", language: "te", isEnabled: false, audioUrl: "", subtitlesUrl: "" },
          // ta: { name: "", language: "ta", isEnabled: false, audioUrl: "", subtitlesUrl: "" },
          // ml: { name: "", language: "ml", isEnabled: false, audioUrl: "", subtitlesUrl: "" },
          // hi: { name: "", language: "hi", isEnabled: false, audioUrl: "", subtitlesUrl: "" },
        },
      }));
    }
  }, [editedData.sampleAudioGuide]);

  const getPackageDetailsById = async (id) => {
    try {
      const data = await PackageServices.getPackageDetailsById(id);
      // setPackageData(data);
      console.log("editedData", data);
      setEditedData(data); // Initialize editable data
    } catch (error) {
      console.error("Error fetching package details:", error);
    }
  };

  const handleLanguageChange = (event) => {
    setSelectedLanguage(event.target.value);
  };

  // const handleInputChange = (field, value) => {
  //   setEditedData((prevData) => ({
  //     ...prevData,
  //     [field]:
  //       typeof prevData[field] === "object" && prevData[field][selectedLanguage]
  //         ? {
  //             ...prevData[field],
  //             [selectedLanguage]: value,
  //           }
  //         : value,
  //   }));
  // };

  // const handleInputChange1 = (field, value) => {
  //   setPackageData((prevData) => {
  //     if (field.includes(".")) {
  //       // Handle nested language fields (e.g., listTitle.en, placesIncluded.placeId.fullName.en)
  //       const [mainField, subField, language] = field.split("."); // Split the field into mainField, subField, and language

  //       // Check if it's a nested language-specific field (like listTitle.en, placesIncluded.placeId.fullName.en)
  //       if (prevData[mainField] && typeof prevData[mainField] === "object") {
  //         return {
  //           ...prevData,
  //           [mainField]: {
  //             ...prevData[mainField],
  //             [subField]: {
  //               ...prevData[mainField][subField],
  //               [language]: value, // Update the specific language field (e.g., "en", "kn")
  //             },
  //           },
  //         };
  //       }
  //     }

  //     // Handle non-nested fields directly
  //     return {
  //       ...prevData,
  //       [field]: value, // Update the value for the field
  //     };
  //   });
  // };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    console.log("Input change detected:", { name, value, selectedLanguage });
    const language = selectedLanguage || "en";

 // Handle special case for isAutoBid dropdown
  if (name === "biddingConfiguration.isAutoBid") {
    setEditedData(prev => ({
      ...prev,
      biddingConfiguration: {
        ...prev.biddingConfiguration,
        isAutoBid: value === "true" // Convert string to boolean
      }
    }));
    return; // Early return since we handled this case
  }

    if (name === "location") {
      setEditedData((prev) => ({
        ...prev,
        location: {
          ...prev.location,
          [e.target.dataset.field]: value,
        },
      }));
    } else if (
      name.startsWith("sliderImages") ||
      name.startsWith("availableTimeSlots")
    ) {
      const fieldName = name.split("-")[0];
      console.log("fieldName", fieldName);
      const index = parseInt(name.split("-")[1], 10);
      const updatedArray = [...editedData[fieldName]];
      updatedArray[index] = value;
      setEditedData((prev) => ({
        ...prev,
        [fieldName]: updatedArray,
      }));
    } else if (
      name.startsWith("bestSeasons") ||
      name.startsWith("tags") ||
      name.startsWith("rules") ||
      name.startsWith("tips") ||
      name.startsWith("additionalNote")
      // name.startsWith("sampleAudioGuide")
    ) {
      // For fields like nearbyPlaces, tags, or rules that have array values
      const fieldName = name.split("-")[0];
      const index = parseInt(name.split("-")[1], 10); // Assuming the index of the array item
      setEditedData((prev) => ({
        ...prev,
        [fieldName]: {
          ...prev[fieldName],
          [language]: [
            ...prev[fieldName][language].slice(0, index),
            value, // Update the specific item at the index
            ...prev[fieldName][language].slice(index + 1), // Ensure the other items remain intact
          ],
        },
      }));
    } else if (name.startsWith("sampleAudioGuide")) {
      // Handle sampleAudioGuide-object-based fields
      const [, lang, field] = name.split("-");
      setEditedData((prev) => ({
        ...prev,
        sampleAudioGuide: {
          ...prev.sampleAudioGuide,
          [lang]: {
            ...prev.sampleAudioGuide[lang],
            [field]: value,
          },
        },
      }));
    } else if (name.startsWith("audioGuide")) {
      const [, lang, subKey, subField] = name.split("-");
      setEditedData((prev) => {
        const current = prev.audioGuide?.[lang] || {};
        // Handle nested fields like short.audioUrl
        if (subField) {
          return {
            ...prev,
            audioGuide: {
              ...prev.audioGuide,
              [lang]: {
                ...current,
                [subKey]: {
                  ...current[subKey],
                  [subField]: value,
                },
              },
            },
          };
        } else {
          return {
            ...prev,
            audioGuide: {
              ...prev.audioGuide,
              [lang]: {
                ...current,
                [subKey]: value,
              },
            },
          };
        }
      });
    } else if (
      name.includes("listTitle") ||
      name.includes("listHeading") ||
      name.includes("listSubheading") ||
      name.includes("detailTitle") ||
      name.includes("detailHeading") ||
      name.includes("detailSubheading") ||
      name.includes("detailDescription_1") ||
      name.includes("detailDescription_2") ||
      name.includes("detailHeading") ||
      name.includes("bookingLockedReason")
    ) {
      // const fieldName = name.split("-")[0];
      setEditedData((prev) => ({
        ...prev,
        [name]: {
          ...prev[name],
          [language]: value, // Update the specific language field
        },
      }));
    } else if (name === "requiresEntryFee") {
      setEditedData((prev) => ({
        ...prev,
        [name]: checked, // Here we directly use 'checked' which is a boolean value
      }));
    } else if (name.includes(".")) {
      // Handle nested properties like "biddingConfiguration.key"
      const [parentKey, childKey] = name.split(".");
      setEditedData((prev) => ({
        ...prev,
        [parentKey]: {
          ...prev[parentKey],
          [childKey]: type === "number" ? Number(value) : value,
        },
      }));
    } else {
      setEditedData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // const handleInputChange = (field, value, language = selectedLanguage) => {
  //   setPackageData((prevData) => {
  //     if (typeof prevData[field] === "object" && prevData[field][language] !== undefined) {
  //       return {
  //         ...prevData,
  //         [field]: {
  //           ...prevData[field],
  //           [language]: value,
  //         },
  //       };
  //     }
  //     return {
  //       ...prevData,
  //       [field]: value,
  //     };
  //   });
  // };

  const handleSubmit = async (id) => {
    // Submit updated data
    let response;
    try {
      if (isEditMode) {
        response = await PackageServices.updatePackageDetailsById(
          id,
          editedData
        );
        console.log("response", response);
        if (response._id) {
          setSuccessMessage("Package updated successfully!");
        } else {
          setErrorMessage("Failed to save package details. Please try again.");
        }
      } else {
        response = await PackageServices.addPackage(editedData);
        console.log("response", response);
        if (response._id) {
          setSuccessMessage("Package created successfully!");
        } else {
          setErrorMessage("Failed to save package details. Please try again.");
        }
      }
    } catch (error) {
      setErrorMessage("Failed to save package details. Please try again.");
    }
  };

  if (!editedData) {
    return <Typography>Loading package details...</Typography>;
  }

  const getPlaces = async () => {
    try {
      const res = await PlaceServices.getPlaces();
      setPlaces(res);
      console.log("response from the get places ", res);
    } catch (error) {
      console.log("error while getting the places", error);
    }
  };

  const handlePlacesChange = (index, field, value) => {
    console.log("editedData.placesIncluded", editedData.placesIncluded);
    const updatedPlaces = [...editedData.placesIncluded];
    updatedPlaces[index][field] = value;
    setEditedData((prevState) => ({
      ...prevState,
      placesIncluded: updatedPlaces,
    }));
  };

  const handleAddPlace = (place) => {
    setEditedData((prevState) => ({
      ...prevState,
      placesIncluded: [
        ...prevState.placesIncluded,
        { placeId: place, sequence: prevState.placesIncluded.length + 1 },
      ],
    }));
  };

  const handleDeletePlace = (index) => {
    const updatedPlaces = [...editedData.placesIncluded];
    updatedPlaces.splice(index, 1); // Remove the place at the specified index
    setEditedData((prevState) => ({
      ...prevState,
      placesIncluded: updatedPlaces, // Update the placesIncluded array in state
    }));
  };

  const sortPlaces = () => {
    setEditedData({
      ...editedData,
      placesIncluded: [...editedData.placesIncluded].sort(
        (a, b) => a.sequence - b.sequence
      ),
    });
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;

    if (name.startsWith("sampleAudioGuide")) {
      const [, lang, field] = name.split("-");
      setEditedData((prev) => ({
        ...prev,
        sampleAudioGuide: {
          ...prev.sampleAudioGuide,
          [lang]: {
            ...prev.sampleAudioGuide[lang],
            [field]: checked,
          },
        },
      }));
    } else if (name.startsWith("audioGuide")) {
      const [, lang, subKey, subField] = name.split("-");
      setEditedData((prev) => {
        const current = prev.audioGuide?.[lang] || {};
        if (subField) {
          return {
            ...prev,
            audioGuide: {
              ...prev.audioGuide,
              [lang]: {
                ...current,
                [subKey]: {
                  ...current[subKey],
                  [subField]: checked,
                },
              },
            },
          };
        } else {
          return {
            ...prev,
            audioGuide: {
              ...prev.audioGuide,
              [lang]: {
                ...current,
                [subKey]: checked,
              },
            },
          };
        }
      });
    }
  };

  return (
    <Box p={3}>
      <Typography variant="h4">
        {isEditMode ? "Edit Package" : "Create Package"}
      </Typography>

      {/* Language Selection Section */}
      <Box mt={3} sx={styles.sectionBox}>
        {/* Header with Background and Text Style */}
        <Typography variant="h6" sx={styles.sectionHeader}>
          Language Selection
        </Typography>

        {/* Language Selection Form */}
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              select
              label="Select Language"
              value={selectedLanguage}
              onChange={handleLanguageChange}
              fullWidth
              margin="normal"
              sx={styles.textField}
            >
              {Object.keys(editedData.listTitle).map((lang) => (
                <MenuItem key={lang} value={lang} sx={styles.menuItem}>
                  {lang.toUpperCase()}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Priority"
              value={editedData.priority}
              name="priority"
              onChange={handleInputChange}
              fullWidth
              margin="normal"
              sx={styles.textField}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              select
              label="Is Audio Guide Enabled"
              value={editedData.isEnabledAudioGuide || ""}
              onChange={handleInputChange}
              margin="normal"
              name="isEnabledAudioGuide"
            >
              <MenuItem value="true">true</MenuItem>
              <MenuItem value="false">false</MenuItem>
            </TextField>
          </Grid>
        </Grid>
      </Box>

      <Divider sx={{ my: 2 }} />

      <Box mt={3} sx={styles.sectionBox}>
        <Typography variant="h6" sx={styles.sectionHeader}>
          City Title Section
        </Typography>

        {/* Multi-language Fields */}

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              label="Type"
              name="type"
              value={editedData.type || ""}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="City"
              name="city"
              value={editedData.city || ""}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="City Scope"
              name="cityScope"
              value={editedData.cityScope || ""}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
            />
          </Grid>
        </Grid>
      </Box>

      {/* List Title Section */}
      <Box mt={3} sx={styles.sectionBox}>
        {/* Header with Background and Text Style */}
        <Typography variant="h6" sx={styles.sectionHeader}>
          List Title Section
        </Typography>

        {/* List Title Form */}
        <Grid container spacing={2}>
          {/* List Title Field */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="List Title"
              name="listTitle"
              value={editedData.listTitle[selectedLanguage] || ""}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
              sx={styles.textField}
            />
          </Grid>

          {/* List Heading Field */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="List Heading"
              name="listHeading"
              value={editedData.listHeading?.[selectedLanguage] || ""}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
              sx={styles.textField}
            />
          </Grid>

          {/* List Subheading Field */}
          <Grid item xs={12}>
            <TextField
              label="List Subheading"
              name="listSubheading"
              value={editedData.listSubheading?.[selectedLanguage] || ""}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
              multiline
              minRows={2}
              maxRows={10}
              sx={styles.textField}
            />
          </Grid>
        </Grid>
      </Box>

      <Divider sx={{ my: 2 }} />

      {/* Detail Section */}
      <Box mt={3} sx={styles.sectionBox}>
        <Typography variant="h6" sx={styles.sectionHeader}>
          Detail Section
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              label="Detail Title"
              name="detailTitle"
              value={editedData.detailTitle?.[selectedLanguage] || ""}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
              sx={styles.textField}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Detail Heading"
              name="detailHeading"
              value={editedData.detailHeading?.[selectedLanguage] || ""}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
              sx={styles.textField}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Detail Subheading"
              name="detailSubheading"
              value={editedData.detailSubheading?.[selectedLanguage] || ""}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
              sx={styles.textField}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Detail Description (1)"
              name="detailDescription_1"
              value={editedData.detailDescription_1?.[selectedLanguage] || ""}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
              sx={styles.textField}
              multiline // Enables multiline input
              minRows={4} // Use minRows for dynamic row adjustment
              maxRows={10} // Maximum number of rows to expand
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Detail Description (2)"
              name="detailDescription_2"
              value={editedData.detailDescription_2?.[selectedLanguage] || ""}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
              multiline // Enables multiline input
              minRows={4} // Initial number of rows
              maxRows={10} // Maximum number of rows to expand
              sx={styles.textField}
            />
          </Grid>
        </Grid>
      </Box>

      <Divider sx={{ my: 2 }} />

      {/* Images and Media Section */}
      <Box mt={3} sx={styles.sectionBox}>
        <Typography variant="h6" sx={styles.sectionHeader}>
          Images and Media
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Thumbnail Image URL"
              name="thumbnailImage"
              value={editedData.thumbnailImage || ""}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
              sx={styles.textField}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Background Type"
              name="backgroundType"
              value={editedData.backgroundType || ""}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
              sx={styles.textField}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Background URL"
              name="backgroundURL"
              value={editedData.backgroundURL || ""}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
              sx={styles.textField}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Feature Video"
              name="featureVideo"
              value={editedData.featureVideo || ""}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
              sx={styles.textField}
            />
          </Grid>
          <Grid item xs={12}>
            {/* <TextField
            label="Slider Images"
            name="sliderImages"
            value={editedData.sliderImages.join(", ")}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
          /> */}
            {editedData.sliderImages.map((image, index) => (
              <TextField
                key={`sliderImage-${index}`}
                label={`Slider Image ${index + 1} URL`}
                name={`sliderImages-${index}`}
                value={image}
                onChange={handleInputChange}
                fullWidth
                sx={styles.textFieldSlider}
                // error={!!errors.sliderImages}
                // helperText={errors.sliderImages}
              />
            ))}
          </Grid>
        </Grid>
      </Box>

      <Divider sx={{ my: 2 }} />

      {/* Seasonal and Tag Information */}
      <Box mt={3} sx={styles.sectionBox}>
        <Typography variant="h6" sx={styles.sectionHeader}>
          Seasonal and Tag Information
        </Typography>

        {["bestSeasons", "tags"].map((field) => (
          <React.Fragment key={field}>
            {editedData[field][selectedLanguage]?.map((item, index) => (
              <TextField
                key={`${field}-${index}`}
                label={`${field.charAt(0).toUpperCase() + field.slice(1)} ${
                  index + 1
                }`}
                name={`${field}-${index}`}
                value={item}
                onChange={handleInputChange}
                fullWidth
                sx={styles.textFieldSlider}
              />
            ))}
            {/* <Button
                  onClick={() => handleAddField(field)}
                  color="primary"
                  sx={{ mb: 2 }}
                >
                  Add {field.charAt(0).toUpperCase() + field.slice(1)}
                </Button> */}
          </React.Fragment>
        ))}
      </Box>
      {/* <Box mt={3}>
      <Typography variant="h6">Seasonal and Tag Information</Typography>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            label="Best Season"
            name="bestSeasons"
            value={editedData.bestSeasons?.[selectedLanguage].join(", ") || ""}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            helperText="Enter seasons separated by commas"
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="Tags"
            name="tags"
            value={editedData.tags?.[selectedLanguage].join(", ") || ""}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            helperText="Enter tags separated by commas"
          />
        </Grid>
      </Grid>
    </Box> */}

      <Divider sx={{ my: 2 }} />

      {/* Timing and Duration Section */}
      <Box mt={3} sx={styles.sectionBox}>
        <Typography variant="h6" sx={styles.sectionHeader}>
          Timing and Duration
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              label="Start Time"
              type="datetime-local"
              name="startTime"
              value={
                editedData.startTime
                  ? editedData.startTime.substring(0, 16)
                  : ""
              }
              onChange={handleInputChange}
              fullWidth
              margin="normal"
              sx={styles.textField}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="End Time"
              type="datetime-local"
              name="endTime"
              value={
                editedData.endTime ? editedData.endTime.substring(0, 16) : ""
              }
              onChange={handleInputChange}
              fullWidth
              margin="normal"
              sx={styles.textField}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Book Before Time"
              type="datetime-local"
              name="bookBeforeTime"
              value={
                editedData.bookBeforeTime
                  ? editedData.bookBeforeTime.substring(0, 16)
                  : ""
              }
              onChange={handleInputChange}
              fullWidth
              margin="normal"
              sx={styles.textField}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Total Days"
              type="number"
              name="totalDays"
              value={editedData.totalDays || ""}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
              sx={styles.textField}
            />
          </Grid>
        </Grid>
      </Box>

      <Divider sx={{ my: 2 }} />

      <TextField
        label="Minimum Places to End Trip"
        type="number"
        name="minimumPlacesToEndTrip"
        value={editedData.minimumPlacesToEndTrip || 0}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        sx={styles.textField}
      />

      <Box mt={3} sx={styles.sectionBox}>
        <Typography variant="h6" sx={styles.sectionHeader}>
          Bidding Configuration
        </Typography>
        {/* Dynamic Fields for Bidding Configuration */}
        {/* <Grid container spacing={2}>
          {Object.entries(editedData.biddingConfiguration || {})
            .filter(([key]) => key !== "_id")
            .map(([key, value]) => (
              <Grid item xs={6} key={key}>
                <TextField
                  label={key
                    .replace(/([A-Z])/g, " $1")
                    .replace(/^./, (str) => str.toUpperCase())}
                  type="number"
                  name={`biddingConfiguration.${key}`}
                  value={value || 0}
                  onChange={handleInputChange}
                  fullWidth
                  margin="normal"
                  sx={styles.textField}
                />
              </Grid>
            ))}
        </Grid> */}

        <Grid container spacing={2}>
  {Object.entries(editedData.biddingConfiguration || {})
    .filter(([key]) => key !== "_id")
    .map(([key, value]) => (
      <Grid item xs={6} key={key}>
        {key === "isAutoBid" ? (
          <FormControl fullWidth margin="normal" sx={styles.textField}>
            <InputLabel>Auto Bid</InputLabel>
            <Select
              name={`biddingConfiguration.${key}`}
              value={value ? "true" : "false"}
              onChange={handleInputChange}
              label="Auto Bid"
            >
              <MenuItem value="true">Yes</MenuItem>
              <MenuItem value="false">No</MenuItem>
            </Select>
          </FormControl>
        ) : (
          <TextField
            label={key
              .replace(/([A-Z])/g, " $1")
              .replace(/^./, (str) => str.toUpperCase())}
            type="number"
            name={`biddingConfiguration.${key}`}
            value={value || 0}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            sx={styles.textField}
          />
        )}
      </Grid>
    ))}
</Grid>
      </Box>
      <Divider />
      <Box mt={3} sx={styles.sectionBox}>
        <Typography variant="h6" sx={styles.sectionHeader}>
          Available Slots
        </Typography>
        <Grid container spacing={2} mt={2}>
          {editedData.availableTimeSlots?.map((slot, index) => {
            // console.log("editedData.availableTimeSlots",slot)
            return (
              <Grid item xs={6} key={index}>
                <TextField
                  key={`Available Slot-${index}`}
                  label={`Available Slot ${index + 1}`}
                  name={`availableTimeSlots-${index}`}
                  type="datetime-local"
                  // value={editedData.bookBeforeTime ? editedData.bookBeforeTime.substring(0, 16) : ""}
                  value={slot ? slot.substring(0, 16) : ""}
                  onChange={handleInputChange}
                  sx={styles.textField}
                  size="small"
                />
              </Grid>
            );
          })}
        </Grid>
      </Box>
      <Divider />
      <Box mt={3} sx={styles.sectionBox}>
        <Typography variant="h6" sx={styles.sectionHeader}>
          Prices
        </Typography>

        <Grid container spacing={2} mt={2}>
          <Grid item xs={6}>
            <TextField
              label="Ideal Price"
              name="idealPrice"
              // value={editedData.bookBeforeTime ? editedData.bookBeforeTime.substring(0, 16) : ""}
              value={editedData.idealPrice}
              // onChange={(e) =>
              //   handlePlacesChange(index, "sequence", e.target.value)
              // }
              onChange={handleInputChange}
              sx={styles.textField}
              size="small"
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="PricePerKm"
              name="pricePerKm"
              // value={editedData.bookBeforeTime ? editedData.bookBeforeTime.substring(0, 16) : ""}
              value={editedData.pricePerKm}
              // onChange={(e) =>
              //   handlePlacesChange(index, "sequence", e.target.value)
              // }
              onChange={handleInputChange}
              sx={styles.textField}
              size="small"
            />
          </Grid>
        </Grid>
      </Box>

      <Box mt={3} sx={styles.sectionBox}>
        <Typography variant="h6" sx={styles.sectionHeader}>
          Additional Note
        </Typography>

        {["additionalNote"].map((field) => (
          <React.Fragment key={field}>
            {editedData[field]?.[selectedLanguage]?.map((item, index) => (
              <TextField
                key={`${field}-${index}`}
                label={`${field.charAt(0).toUpperCase() + field.slice(1)} ${
                  index + 1
                }`}
                name={`${field}-${index}`}
                value={item}
                onChange={handleInputChange}
                fullWidth
                sx={styles.textField}
              />
            ))}
          </React.Fragment>
        ))}
      </Box>

      <TextField
        fullWidth
        select
        label="Is Enabled"
        value={editedData.isEnabled || ""}
        onChange={handleInputChange}
        margin="normal"
        name="isEnabled"
      >
        <MenuItem value="true">true</MenuItem>
        <MenuItem value="false">false</MenuItem>
      </TextField>

      <Box mt={3} sx={styles.sectionBox}>
        <Typography variant="h6" sx={styles.sectionHeader}>
          Booking Locked Reason{" "}
        </Typography>
        <TextField
          fullWidth
          select
          label="Booking Locked"
          value={editedData.isBookingLocked || ""}
          onChange={handleInputChange}
          margin="normal"
          name="isBookingLocked"
        >
          <MenuItem value="true">true</MenuItem>
          <MenuItem value="false">false</MenuItem>
        </TextField>

        <Grid item xs={6}>
          <TextField
            label="booking Locked Reason"
            name="bookingLockedReason"
            value={editedData.bookingLockedReason?.[selectedLanguage] || ""}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            multiline // Enables multiline input
            minRows={4} // Initial number of rows
            maxRows={10} // Maximum number of rows to expand
            sx={styles.textField}
          />
        </Grid>
      </Box>

      <Box mt={3} sx={styles.sectionBox}>
        <Typography variant="h6" sx={styles.sectionHeader}>
          Sample Audio Guide
        </Typography>

        {(() => {
          const lang = selectedLanguage;
          const guide = editedData.sampleAudioGuide?.[lang] || {
            name: "",
            language: lang,
            isEnabled: false,
            audioUrl: "",
            subtitlesUrl: "",
          };

          if (!guide) return null; // Skip rendering if undefined

          return (
            <Box
              key={lang}
              sx={{ mb: 3, border: "1px solid #ccc", p: 2, borderRadius: 2 }}
            >
              {/* <Typography variant="subtitle1" sx={{ mb: 2 }}>
                {`${guide.name || "Audio Guide"} (${lang.toUpperCase()})`}
              </Typography> */}

              <TextField
                label="Name"
                name={`sampleAudioGuide-${lang}-name`}
                value={guide.name}
                onChange={handleInputChange}
                fullWidth
                sx={styles.textField}
              />

              <TextField
                label="Language"
                name={`sampleAudioGuide-${lang}-language`}
                value={guide.language}
                onChange={handleInputChange}
                fullWidth
                sx={styles.textField}
              />

              <TextField
                label="Audio URL"
                name={`sampleAudioGuide-${lang}-audioUrl`}
                value={guide.audioUrl}
                onChange={handleInputChange}
                fullWidth
                sx={styles.textField}
              />

              <TextField
                label="Subtitles URL"
                name={`sampleAudioGuide-${lang}-subtitlesUrl`}
                value={guide.subtitlesUrl}
                onChange={handleInputChange}
                fullWidth
                sx={styles.textField}
              />

              <FormControlLabel
                control={
                  <Checkbox
                    name={`sampleAudioGuide-${lang}-isEnabled`}
                    checked={guide.isEnabled}
                    onChange={handleCheckboxChange}
                  />
                }
                label="Is Enabled"
              />
            </Box>
          );
        })()}
      </Box>

      <Box mt={3} sx={styles.sectionBox}>
        <Typography variant="h6" sx={styles.sectionHeader}>
          Audio Guide
        </Typography>

        {(() => {
          const lang = selectedLanguage || "en";
          const guide = editedData.audioGuide?.[lang] || {
            name: "",
            language: lang,
            isEnabled: false,
            short: {  audioUrl: "", subtitlesUrl: "" },
            medium: { audioUrl: "", subtitlesUrl: "" },
            long: {audioUrl: "", subtitlesUrl: "" },
          };

          const durations = ["short", "medium", "long"];

          return (
            <Box
              key={lang}
              sx={{ mb: 3, border: "1px solid #ccc", p: 2, borderRadius: 2 }}
            >
              {/* <Typography variant="subtitle1" sx={{ mb: 2 }}>
                {`${guide.name || "Audio Guide"} (${lang.toUpperCase()})`}
              </Typography> */}

              <TextField
                label="Name"
                name={`audioGuide-${lang}-name`}
                value={guide.name}
                onChange={handleInputChange}
                fullWidth
                sx={styles.textField}
              />

              <TextField
                label="Language"
                name={`audioGuide-${lang}-language`}
                value={guide.language}
                onChange={handleInputChange}
                fullWidth
                sx={styles.textField}
              />

              <FormControlLabel
                control={
                  <Checkbox
                    name={`audioGuide-${lang}-isEnabled`}
                    checked={guide.isEnabled}
                    onChange={handleCheckboxChange}
                  />
                }
                label="Audio Guide Enabled"
              />

              {durations.map((duration) => (
                <Box key={duration} sx={{ mt: 2, pl: 2 }}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    {duration.charAt(0).toUpperCase() + duration.slice(1)} Guide
                  </Typography>

                  {/* <FormControlLabel
                    control={
                      <Checkbox
                        name={`audioGuide-${lang}-${duration}-isEnabled`}
                        checked={guide[duration]?.isEnabled || false}
                        onChange={handleCheckboxChange}
                      />
                    }
                    label="Enabled"
                  /> */}

                  <TextField
                    label="Audio URL"
                    name={`audioGuide-${lang}-${duration}-audioUrl`}
                    value={guide[duration]?.audioUrl || ""}
                    onChange={handleInputChange}
                    fullWidth
                    sx={styles.textField}
                  />

                  <TextField
                    label="Subtitles URL"
                    name={`audioGuide-${lang}-${duration}-subtitlesUrl`}
                    value={guide[duration]?.subtitlesUrl || ""}
                    onChange={handleInputChange}
                    fullWidth
                    sx={styles.textField}
                  />
                </Box>
              ))}
            </Box>
          );
        })()}
      </Box>

      {/* Places Included Section */}
      <Box mt={3} sx={styles.sectionHeader}>
        <Typography variant="h6" sx={styles.sectionHeader}>
          Places Included
        </Typography>
        <Box sx={{ marginBottom: 2 }}>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              getPlaces();
              setDialogOpen(true);
            }}
          >
            Add Place
          </Button>
        </Box>

        <Grid container spacing={1}>
          {editedData.placesIncluded.map((pkg, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  padding: 1,
                  boxShadow: 2,
                  borderRadius: 1,
                  backgroundColor: "#f9f9f9",
                  "&:hover": {
                    boxShadow: 5,
                    backgroundColor: "#e0e0e0",
                  },
                }}
              >
                <CardMedia
                  component="img"
                  height="140"
                  image={
                    pkg.placeId?.thumbnailImage ||
                    "https://via.placeholder.com/300"
                  }
                  alt={
                    pkg.placeId?.shortName?.[selectedLanguage] ||
                    "No Image Available"
                  }
                  sx={{
                    borderRadius: 1,
                    objectFit: "cover",
                  }}
                />
                <CardContent sx={{ padding: 1, flexGrow: 1 }}>
                  <Typography
                    variant="h6"
                    gutterBottom
                    sx={{
                      fontSize: "1rem",
                      fontWeight: 500,
                      color: "#333",
                    }}
                   
                  >
                   {pkg.placeId?.shortName?.[selectedLanguage] ||
                      "No shortName Available"}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      fontSize: "0.8rem",
                      color: "#555",
                    }}
                  >
                    {pkg.placeId?.fullName?.[selectedLanguage] ||
                      "No Title Available"}
                  </Typography>
                   
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      fontSize: "0.8rem",
                      color: "#555",
                      marginTop:1
                    }}
                  >
                    Priority: {pkg.sequence || "N/A"}
                  </Typography>
                </CardContent>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    padding: 1,
                    justifyContent: "space-between",
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={pkg.isEnabled}
                        onChange={(e) =>
                          handlePlacesChange(
                            index,
                            "isEnabled",
                            e.target.checked
                          )
                        }
                        sx={{
                          color: "#555",
                          "&.Mui-checked": {
                            color: "#00796b",
                          },
                        }}
                      />
                    }
                    label="Enabled"
                    sx={{
                      fontSize: "0.8rem",
                      color: "#333",
                    }}
                  />
                  <TextField
                    label="Priority"
                    type="number"
                    value={pkg.sequence}
                    onChange={(e) =>
                      handlePlacesChange(index, "sequence", e.target.value)
                    }
                    sx={{
                      marginLeft: 1,
                      width: "50%",
                      fontSize: "0.8rem",
                      "& .MuiInputBase-root": {
                        padding: "5px 10px",
                      },
                    }}
                    size="small"
                  />
                </Box>
                <Box sx={{ padding: 1 }}>
                  <Button
                    variant="outlined"
                    size="small"
                    color="error"
                    onClick={() => handleDeletePlace(index)}
                    sx={{
                      width: "100%",
                      fontSize: "0.8rem",
                      textTransform: "none",
                      padding: "6px 12px",
                      "&:hover": {
                        backgroundColor: "#f44336",
                        color: "#fff",
                      },
                    }}
                  >
                    Delete
                  </Button>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
        <Button onClick={() => sortPlaces()}>Sort by Priority</Button>
      </Box>

      <Box mt={3}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleSubmit(id)}
        >
          Save Changes
        </Button>
      </Box>

      {/* Dialog for Selecting Places */}
      <Dialog open={isDialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>Select Places to Add</DialogTitle>
        <DialogContent>
          <List>
            {places.map((place, index) => (
              <ListItem key={index}>
                {/* Place Image */}
                <ListItemAvatar>
                  <Avatar
                    src={place.thumbnailImage}
                    alt={place?.fullName?.[selectedLanguage]}
                    sx={{ width: 56, height: 56 }}
                  />
                </ListItemAvatar>
                {/* Place Full Name */}
                <ListItemText
                  primary={place?.fullName?.[selectedLanguage]}
                  primaryTypographyProps={{
                    variant: "subtitle1",
                    fontWeight: "bold",
                  }}
                />
                {/* Add Button */}
                <ListItemSecondaryAction>
                  <IconButton
                    edge="end"
                    color="primary"
                    onClick={() => handleAddPlace(place)}
                  >
                    <AddCircleIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={Boolean(successMessage)}
        autoHideDuration={3000}
        onClose={() => setSuccessMessage("")}
      >
        <Alert
          onClose={() => setSuccessMessage("")}
          severity="success"
          sx={{ width: "100%" }}
        >
          {successMessage}
        </Alert>
      </Snackbar>

      <Snackbar
        open={Boolean(errorMessage)}
        autoHideDuration={3000}
        onClose={() => setErrorMessage("")}
      >
        <Alert
          onClose={() => setErrorMessage("")}
          severity="error"
          sx={{ width: "100%" }}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default EditPackage;
